import { render, staticRenderFns } from "./veHqShen.vue?vue&type=template&id=813194f0&scoped=true"
import script from "./veHqShen.vue?vue&type=script&lang=js"
export * from "./veHqShen.vue?vue&type=script&lang=js"
import style0 from "./veHqShen.vue?vue&type=style&index=0&id=813194f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813194f0",
  null
  
)

export default component.exports